import {pushViewAction} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import CurrentlyUnavailableCard from '../../currently_unavailable_div/CurrentlyUnavailableCard';
import ScheduleInstallments from '../../scheduleInstallments/scheduleInstallments';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';

import {Button} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import './NextFiveInstallment.css';

const NextFiveInstallment = (props) => {
  const scheduleFields = {
    DUE_DATE: 'paymentDueDate',
    AMOUNT: 'installmentAmount',
    REMAINING_BALANCE: 'outstandingBalance',
  };
  const {t} = useTranslation();

  const [schedulePaymentsData, setSchedulePaymentsData] = React.useState(null);
  const nextFiveInstallment = () => (
    <div className="nextFiveInstallment">
      <ScheduleInstallments
        schedulePayments={schedulePaymentsData}
        fields={scheduleFields}
        displayPagination={false}
        showAssets={props.showAssets}
        hideTitle={true}
        selectedContractNumber={props.contractNumber}
      />
    </div>
  );

  React.useEffect(() => {
    if (props.PaymentSchedule && props.NextFiveInstallment) {
      const paymentSchedule = props.PaymentSchedule?.[props.contractNumber];
      const productType = paymentSchedule?.productLine;

      let schedulePaymentsData = {
        [productType]: props.NextFiveInstallment,
      };
      setSchedulePaymentsData(schedulePaymentsData);
    }
  }, [props.PaymentSchedule, props.NextFiveInstallment]);
  return (
    <div className="accountSummaryCard" id={'accountSummaryCard'}>
      <div className="nextFiveInstallmentWrapper">
        <div className="homeAccountSummaryTitle">
          {t('NEXT_FIVE_INSTALLMENTS')}
        </div>
        <Button
          id="viewAllPaymentSchedule"
          variant="text"
          onClick={() => appStore.dispatch(pushViewAction('paymentSchedule'))}
        >
          {t('VIEW_ALL')}
        </Button>
      </div>

      {props.paymentScheduleLoader ? (
        <SkeletonLoader componentName="nextInstallment" />
      ) : props.paymentScheduleError ? (
        <CurrentlyUnavailableCard
          title={t('SOMETHING_WENT_WRONG')}
          subTitle={t('PAYMENT_SCHEDULE_NOT_AVAILABLE')}
          fullScreen={false}
        />
      ) : (
        nextFiveInstallment()
      )}
    </div>
  );
};
export const mapStateToProps = (state) => {
  return {
    PaymentSchedule:
      state.appStates.paymentSchedule?.paymentSchedules?.installments,
    NextFiveInstallment:
      state.appStates.paymentSchedule?.paymentSchedules?.nextFiveInstallment,
    paymentScheduleLoader: state.appStates.paymentScheduleLoader,
    paymentScheduleError: state.appStates.paymentScheduleError,
  };
};
export default connect(mapStateToProps)(NextFiveInstallment);
